<template>
  <div>
    <Header></Header>
    <div class="banner">
      <img src="@/assets/images/banner2.png" alt="">
    </div>
    <div class="content">
      <div class="title">
        <h3>招标公告  |  象山影视城文化产业集团有限公司关于音响系统 1批的在线询价公告</h3>
        <p>发布时间：2020-12-26  |  招标时间：2021-03-05</p>
      </div>
      <div class="detail">
        <p>招标代理；信息咨询（不含中介服务）；会议服务；组织文化艺术交流活动；投资管理；投资咨询；企业策划；销售机械设备、电子产品、针纺织品、日用品、五金交电、化工产品（不含一类易制毒化学品及危险品）、金属材料、建筑材料、工艺品、矿产品、计算机、软件及辅助设备、通讯设备、办公用品、文化用品、体育用品；货物进出口、技术进出口。招标代理；信息咨询（不含中介服务）；会议服务；组织文化艺术交流活动；投资管理；投资咨询；企业策划；销售机械设备、电子产品、针纺织品、日用品、五金交电、化工产品（不含一类易制毒化学品及危险品）、金属材料、建筑材料、工艺品、矿产品、计算机、软件及辅助设备、通讯设备、办公用品、文化用品、体育用品；货物进出口、技术进出口。招标代理；信息咨询（不含中介服务）；会议服务；组织文化艺术交流活动；投资管理；投资咨询；企业策划；销售机械设备、电子产品、针纺织品、日用品、五金交电、化工产品（不含一类易制毒化学品及危险品）、金属材料、建筑材料、工艺品、矿产品、计算机、软件及辅助设备、通讯设备、办公用品、文化用品、体育用品；货物进出口、技术进出口。招标代理；信息咨询（不含中介服务）；会议服务；组织文化艺术交流活动；投资管理；投资咨询；企业策划；销售机械设备、电子产品、针纺织品、日用品、五金交电、化工产品（不含一类易制毒化学品及危险品）、金属材料、建筑材料、工艺品、矿产品、计算机、软件及辅助设备、通讯设备、办公用品、文化用品、体育用品；货物进出口、技术进出口。招标代理；信息咨询（不含中介服务）；会议服务；组织文化艺术交流活动；投资管理；投资咨询；企业策划；销售机械设备、电子产品、针纺织品、日用品、五金交电、化工产品（不含一类易制毒化学品及危险品）、金属材料、建筑材料、工艺品、矿产品、计算机、软件及辅助设备、通讯设备、办公用品、文化用品、体育用品；货物进出口、技术进出口。招标代理；信息咨询（不含中介服务）；会议服务；组织文化艺术交流活动；投资管理；投资咨询；企业策划；销售机械设备、电子产品、针纺织品、日用品、五金交电、化工产品（不含一类易制毒化学品及危险品）、金属材料、建筑材料、工艺品、矿产品、计算机、软件及辅助设备、通讯设备、办公用品、文化用品、体育用品；货物进出口、技术进出口。招标代理；信息咨询（不含中介服务）；会议服务；组织文化艺术交流活动；投资管理；投资咨询；企业策划；销售机械设备、电子产品、针纺织品、日用品、五金交电、化工产品（不含一类易制毒化学品及危险品）、金属材料、建筑材料、工艺品、矿产品、计算机、软件及辅助设备、通讯设备、办公用品、文化用品、体育用品；货物进出口、技术进出口。招标代理；信息咨询（不含中介服务）；会议服务；组织文化艺术交流活动；投资管理；投资咨询；企业策划；销售机械设备、电子产品、针纺织品、日用品、五金交电、</p>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/assets/components/Header'
import Footer from '@/assets/components/Footer'
export default {
  name: "NewsDetail",
  components: {
    Header,
    Footer
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~styles/public.styl"
.banner, .banner img
  width 100%
  height 400px
.content
  width 1200px
  margin 35px auto
  .title
    padding 35px 0
    text-align center
    border-bottom 1px solid #e5e5e5
    h3
      font-size 20px
      color #333
      margin-bottom 25px
    p
      font-size 14px
      color $main-blue
  .detail
    margin-top 40px
    min-height 500px
    p
      font-size 14px
      color #333
      line-height 35px
      text-indent 28px
</style>



// WEBPACK FOOTER //
// src/pages/NewsDetail/NewsDetail.vue